/**
 * One reading-session look everywhere (Chris, 2026-10-29: "the stuff at the
 * top needs to go, except for the image… ensure the X in the top right… we
 * should combine the reading session"). A regular reading, a card drawn from
 * a lesson, the full reading from a lesson, Talk it over, and a gift
 * recipient's own reading (or one for her people) all open in front of the
 * Mystic: their portrait with its glow, and a round ✕ top right. No title,
 * no "with …", no back link, no label of where it came from.
 *
 * The pure rules of it; ReaderPage draws the header.
 */
import { roomToReturnTo } from '@/utils/stage-two'

/**
 * The top pane's share during the interview: the Mystic over the
 * conversation. A regular reading's interview and their own reading from a
 * gift room take the same split.
 */
export function interviewTopPct ({ wide = true } = {}) {
  return wide ? 36 : 40
}

/**
 * Where the session's ✕ goes: back where she came from.
 *  - 'lesson'    a reading from a lesson (draw, talk, or the full reading): the lesson
 *  - 'gift-room' a reading started in a gift room (hers, or for one of her people): the room
 *  - 'mystic'    anything else: out of the session to the Mystic, as "Exit Reading" does
 */
export function sessionCloseTarget ({ lesson = null, own = null } = {}) {
  if (lesson && lesson.short_uuid) return 'lesson'
  if (roomToReturnTo(own)) return 'gift-room'
  return 'mystic'
}
